import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  gridContainer: {
    display: 'flex',
  },
  leftSide: {
    height: '100%',
    width: '50%',
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  leftSideContent: {
    padding: '35px 70px 30px 190px',
    '@media (max-width: 1024px)': {
      padding: '20px 30px 20px 30px',
    },
    '@media (max-width: 767px)': {
      padding: '25px 5%',
    },
  },
  imgBox: {
    paddingBottom: 85,
    marginLeft: -6,
    '@media (max-width: 767px)': {
      paddingBottom: 35,
    },
  },
  logoIcon: {},
  welcome8vdx: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.warning.contrastText,
  },
  welcomeSub8vdx: {
    color: theme.palette.warning.light,
    fontSize: 16,
    fontWeight: 400,
  },
  validateForm: {
    paddingTop: 43,
  },
  labelText: {
    fontSize: 15,
    color: theme.palette.grey[50],
    fontWeight: 500,
    marginBottom: 5,
  },
  controllerBox: {
    position: 'relative',
  },
  textValInput: {
    marginBottom: 35,
    width: '100%',
  },
  inputRoot: {
    fontSize: 16,
    width: '100%',
    '&:hover': {
      '&:not(.Mui-disabled)::before': {
        borderBottomColor: theme.palette.primary.light,
      },
    },
  },
  labelRoot: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 15,
    letterSpacing: 0.35,
  },
  labelFocused: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 15,
    transform: 'translate(0, 1.5px) scale(1)',
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 13,
    position: 'absolute',
    bottom: 0,
    display: 'block',
    textAlign: 'left',
  },
  signupBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    marginTop: 25,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 16,
    width: '100%',
    height: 57,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  errorAlready: {
    color: theme.palette.error.main,
    fontSize: 14,
    position: 'relative',
    marginBottom: 0,
    paddingRight: 5,
    // paddingTop: 10,
    fontFamily: theme.typography.fontFamily,
  },
  alreadyAcText: {
    color: theme.palette.common.black,
    opacity: 0.6,
    marginBottom: 22,
    marginTop: 30,
    fontSize: 14,
    '@media (max-width: 767px)': {
      marginBottom: 15,
      marginTop: 15,
    },
  },
  signInLink: {
    color: theme.palette.grey.A200,
    cursor: 'pointer',
  },
  copyText: {
    color: theme.palette.grey[200],
    fontSize: 14,
  },
}));
